import React, { Component } from 'react';
import { PrimeIcons } from 'primereact/api';
import { Card } from 'primereact/card';

export class Home extends Component {
	constructor(props) {
        super(props);
        this.state = {};
    }
	
	async componentDidMount() {
	}

	render() {
		return (
			<div className="flex flex-wrap align-items-center justify-content-center gap-3 h-20rem">
				<div className="">
					<a href="/approved">
					    <Card className="align-items-center justify-content-center w-20rem" style={{ textAlign: "center", backgroundColor: "#17345b", color: "#FFFFFF" }}>
						    <i className="pi pi-verified" style={{ 'fontSize': '2em' }}></i><br /><br />
						    Approved Vendors
						</Card>
                    </a>
				</div>
				<div className="">
					<a href="/paid">
						<Card className="align-items-center justify-content-center w-20rem" style={{ textAlign: "center", backgroundColor: "#17345b", color: "#FFFFFF" }}>
							<i className="pi pi-dollar" style={{ 'fontSize': '2em' }}></i><br /><br />
							Paid Vendors
                        </Card>
                    </a>
				</div>
			</div>
		);
	}	
}